import useAxiosMutation from 'hooks/useAxiosMutation';
import { useQueryClient } from 'react-query';
import { BLUEPRINT_SHARED_TOKEN_CACHE_KEY } from 'services/queryKeys';

type UpdateSharedBlueprintExpirationParams = {
  blueprintId: number;
  shareToken: string;
  tsExpiration: string;
};

export const useUpdateSharedBlueprintExpiration = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isError, error } = useAxiosMutation();

  const updateExpiration = async ({ blueprintId, shareToken, tsExpiration }: UpdateSharedBlueprintExpirationParams) => {
    const result = await mutateAsync({
      method: 'PATCH',
      path: `/blueprints/${blueprintId}/shared/${shareToken}/`,
      body: {
        ts_expiration: tsExpiration,
      },
    });

    // Invalidate cache to refetch updated token
    queryClient.invalidateQueries(BLUEPRINT_SHARED_TOKEN_CACHE_KEY(blueprintId));

    return result;
  };

  return {
    updateExpiration,
    isLoading,
    isError,
    error,
  };
};
